import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Container, useMediaQuery,
} from '@mui/material';
import Spinner from '../../../../components/Spinner/index';
import Tabs from '../../../../components/Tabs/TabsEquipment';
import AttachmentsListEquipments from '../AttachmentsListEquipments';
import ListEquipmentModelsByEquipment from '../ListEquipmentModelsByEquipment';
import * as actions from "../../../../store/actions";

const styles = {
  container: {
    padding: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 20,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignGroups: 'center',
  },
  spinner: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    top: '-5px',
    opacity: '1',
    zIndex: 2,
  },
};

const FormEquipmentsAttachmentFiles = (props) => {
  const dispatch = useDispatch();
  const matches = useMediaQuery('(min-width:1200px)');
  const attachmentFilesLoading = useSelector(state => state.equipments.loadingDocument);

  const equipment = useSelector((state) => state.equipments.equipment);
  const fetchEquipmentModels = useCallback(
    () => dispatch(actions.fetchEquipmentModelById(equipment.equipmentModel._id))
  ) || [];
  

  useEffect(() => {
    equipment._id && fetchEquipmentModels();
  }, [equipment._id])

  return (
    <>
      <Tabs {...props} selected={'attachmentsTab'} />

      <div style={matches ? styles.divContainer : styles.divContainerSmall}>
        <Container maxWidth='sm' style={styles.container}>
          {attachmentFilesLoading && 
            <div style={styles.spinner}>
              <Spinner />
            </div>}      
          {!attachmentFilesLoading && <AttachmentsListEquipments fullWidth/>}
        </Container>
      </div>

      <div style={matches ? styles.divContainer : styles.divContainerSmall}>
        <Container maxWidth='sm' style={styles.container}>
          {attachmentFilesLoading && 
            <div style={styles.spinner}>
              <Spinner />
            </div>}      

          {!attachmentFilesLoading && <ListEquipmentModelsByEquipment fullWidth/>}
        </Container>
      </div>
    </>
  )
}

export default FormEquipmentsAttachmentFiles;
